<button class="main" type="text">
  {{ buttonText }}
</button>
